<script setup lang="ts">
import type { CarouselEmits, CarouselProps, WithClassAsProps } from '@/components/lib/shadcn-vue/carousel/interface';
import { useProvideCarousel } from '@/components/lib/shadcn-vue/carousel/useCarousel';
import { cn } from '@/components/lib/shadcn-vue/utils';

const props = withDefaults(defineProps<CarouselProps & WithClassAsProps>(), {
  orientation: 'horizontal',
});

const emits = defineEmits<CarouselEmits>();

const carouselArgs = useProvideCarousel(props, emits);

defineExpose(carouselArgs);

function onKeyDown(event: KeyboardEvent) {
  const prevKey = props.orientation === 'vertical' ? 'ArrowUp' : 'ArrowLeft';
  const nextKey = props.orientation === 'vertical' ? 'ArrowDown' : 'ArrowRight';

  if (event.key === prevKey) {
    event.preventDefault();
    carouselArgs.scrollPrev();

    return;
  }

  if (event.key === nextKey) {
    event.preventDefault();
    carouselArgs.scrollNext();
  }
}
</script>

<template>
  <div aria-roledescription="carousel" role="region" tabindex="0" :class="cn('relative', props.class)" @keydown="onKeyDown">
    <slot v-bind="carouselArgs" />
  </div>
</template>
